import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import RteViewer from 'app/components/common/rich-text/viewer';
import Field from 'app/components/forms/field';
import formsHelpers from 'app/helpers/forms';
import FormsDuck from 'app/ducks/forms';
import paths from 'app/paths';
import history from 'app/history';

const defaultOnAfterSubmit = (form, formSubmission) => {
  const path = paths.formSubmission(formSubmission.id);
  history.push(path);
};

class Form extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      answers: {},
      submitPending: false,
    };

    this.fieldRefs = {};

    this.onAnswer = this.onAnswer.bind(this);
    this.onClickBack = this.onClickBack.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
  }

  get company() {
    return this.props.company || this.props.form?.company || null;
  }

  get fields() {
    return this.props.form.formFields || [];
  }

  get hasRequiredAnswers() {
    return !this.fields.find((field) => {
      const ans = this.state.answers[field.id];
      return !formsHelpers.isValidAnswer(field, ans);
    });
  }

  get answers() {
    return this.fields.map(f => this.state.answers[f.id]);
  }

  get isNew() {
    return !this.props.submission?.id;
  }

  getFieldRef(field) {
    if (!this.fieldRefs[field.id]) {
      this.fieldRefs[field.id] = React.createRef();
    }
    return this.fieldRefs[field.id];    
  }

  onClickBack() {
    this.props.onClickBack && this.props.onClickBack();
  }

  async onClickSubmit() {
    if (this.props.editMode || this.props.previewMode) return;
    const attrs = this.props.getSubmissionAttrs ? this.props.getSubmissionAttrs() : {};
    this.setState({submitPending: true});
    const {formSubmission} = await (this.isNew
      ? this.props.create(this.answers, attrs)
      : this.props.update(this.answers)
    );
    this.setState({submitPending: false});
    await this.props.onAfterSubmit(this.props.form, formSubmission);
  }

  onAnswer(field, answer) {
    this.setState((prevState) => {
      const newAnswers = {...prevState.answers};
      newAnswers[field.id] = answer;
      return {answers: newAnswers};
    });
  }

  render() {
    const {form, submission, editMode, previewMode, onClickBack, submitLabel, hideLogo, allowPartialSave} = this.props;
    // TODO: check that form is present
    const logoUrl = hideLogo ? null : this.company?.logoUrl;

    const btnDisabled = (() => {
      if (this.state.submitPending) return true;
      if (!this.hasRequiredAnswers && !allowPartialSave) return true;
      if (editMode || previewMode)  return true;
      return false;
    })();
    const btnLabel = (() => {
      return this.state.submitPending ? 'Submitting...' : submitLabel;
    })();

    return (
      <div className="box bform" style={{padding: 96, margin: '48px auto', maxWidth: 800}}>
        {!!logoUrl && <img src={logoUrl} alt={this.company.name} style={{maxWidth: 140, margin: '0 auto 48px', display: 'block'}} />}
        <h1 className="bform-h1">{form.title || 'Form'}</h1>
        <RteViewer md={form.description} fontSize="large" className="_mt-24" />
        {this.fields.map((field) => {
          const answer = submission?.formAnswers?.find(a => a.formFieldId === field.id);
          const ref = this.getFieldRef(field);
          return <Field key={field.id} field={field} editMode={editMode} previewMode={previewMode} ref={ref} onAnswer={this.onAnswer} answer={answer} />
        })}

        <div className="_mt-96 _flex _justify-end _align-center">
          {/* {!!onClickBack && ( */}
          {/*   <button className="btn blue secondary" onClick={this.onClickBack}>Back</button> */}
          {/* )} */}
          <button className="btn blue" onClick={this.onClickSubmit} disabled={btnDisabled}>{btnLabel}</button>
        </div>
      </div>
    );
  }

}

Form.propTypes = {
  company: PropTypes.object,
  form: PropTypes.object,
  submission: PropTypes.object,
  getSubmissionAttrs: PropTypes.func,
  editMode: PropTypes.bool,
  previewMode: PropTypes.bool,
  onAfterSubmit: PropTypes.func,
  allowPartialSave: PropTypes.bool, // TODO: implement
  submitLabel: PropTypes.string,
  onClickBack: PropTypes.func,
  hideLogo: PropTypes.bool,
};

Form.defaultProps = {
  editMode: false,
  previewMode: false,
  getSubmissionAttrs: null,
  onAfterSubmit: defaultOnAfterSubmit,
  allowPartialSave: false,
  submitLabel: 'Submit',
  onClickBack: null,
  hideLogo: false,
};

const stateToProps = (state) => ({});
const dispatchToProps = (dispatch, ownProps) => ({
  create: (answers, attrs) => dispatch(FormsDuck.Ax.submissionsCreate(ownProps.form.id, answers, attrs)),
  update: (answers) => dispatch(FormsDuck.Ax.submissionsUpdate(ownProps.submission.id, answers)),
});

export default connect(stateToProps, dispatchToProps)(Form);
